const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/uiReducer.tsx';
import Imm from 'immutable';
import {
    atDismissSnackbar,
    atDismissUncaughtErrorDialog,
    atShowSnackbar,
    atShowUncaughtErrorDialog,
    showUncaughtErrorDialog,
} from '../actions/uiActions';

/**
 * The initial values of this reducer's branch (common values only).
 */
export const initialState = Imm.fromJS({
    general: {
        snackbar: {
            visible: false,
        },
        uncaughtError: {
            visible: false,
        },
    },
});

/**
 * The actual reducer.
 */
export function uiReducer(state = initialState, action: any = {}) {
    switch (action.type) {
        case atShowSnackbar:
            return showSnackbar(state, action);
        case atDismissSnackbar:
            return dismissSnackbar(state, action);
        case atShowUncaughtErrorDialog:
            return showUncaughtError(state, action);
        case atDismissUncaughtErrorDialog:
            return dismissUncaughtError(state, action);
        default:
            return state;
    }
}

function showSnackbar(state: any, action: any) {
    state = state.setIn(['general', 'snackbar', 'message'], action.message);
    state = state.setIn(['general', 'snackbar', 'options'], action.options || null);
    return state.setIn(['general', 'snackbar', 'visible'], true);
}

function dismissSnackbar(state: any, _action: any) {
    return state.setIn(['general', 'snackbar', 'visible'], false);
}

function showUncaughtError(state: any, action: any) {
    return state
        .setIn(['general', 'uncaughtError', 'location'], action.location)
        .setIn(['general', 'uncaughtError', 'message'], action.message)
        .setIn(['general', 'uncaughtError', 'textMapId'], action.textMapId)
        .setIn(['general', 'uncaughtError', 'trace'], action.stack)
        .setIn(['general', 'uncaughtError', 'visible'], true);
}

export function showUncaughtErrorFromRoot(state: any, location: string, exception: any) {
    if (!state) {
        console.log('WARNING - UNCAUGHT ERROR BEFORE STATE WAS INITIALIZED!');
        console.log(location, exception);
        return state;
    }
    state = Object.assign({}, state, { ui: showUncaughtError(state.ui, showUncaughtErrorDialog(location, exception)) });
    return state;
}

function dismissUncaughtError(state: any, _action: any) {
    return state.setIn(['general', 'uncaughtError', 'visible'], false);
}